var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187.61572px",
    height: "47.37317px",
    viewBox: "0 0 187.61572 47.37317",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0348251L40.763 0.0348251L40.763 34.2652L0 34.2652L0 0.0348251Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.166924 0.166529L37.0291 0.166529L37.0291 34.2131L0.166924 34.2131L0.166924 0.166529Z",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0387645 0.0170989L38.6128 0.0170989L38.6128 45.5352L0.0387645 45.5352L0.0387645 0.0170989Z",
    id: "path_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L187.616 0L187.616 47.3732L0 47.3732L0 0Z",
    id: "Group-8",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0 0.2115235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0348251L40.763 0.0348251L40.763 34.2652L0 34.2652L0 0.0348251Z",
    id: "Clip-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7272 1.09863L33.2178 33.6254C33.1307 34.0061 32.7918 34.264 32.417 34.2636L32.417 34.2652L19.6837 34.2652C19.229 34.2652 18.8603 33.8967 18.8603 33.4421C18.8603 33.3582 18.8731 33.2776 18.8961 33.2016L21.4233 22.2558L16.9822 22.2558L14.3574 33.6254C14.2703 34.0061 13.9316 34.264 13.5569 34.2636L13.5569 34.2652L0.82328 34.2652C0.368626 34.2652 -6.96967e-05 33.8967 -6.96967e-05 33.4421C-6.96967e-05 33.3582 0.0124757 33.2776 0.0357079 33.2016L7.54506 0.674873C7.63218 0.294329 7.97114 0.036219 8.34587 0.0366837L8.34587 0.0348251L21.0792 0.0348251C21.5339 0.0348251 21.9026 0.403521 21.9026 0.858175C21.9026 0.941811 21.89 1.02243 21.8668 1.09863L19.4472 11.5789L23.8882 11.5789L26.4054 0.674873C26.4926 0.294329 26.8315 0.036219 27.2063 0.0366837L27.2063 0.0350574L39.9396 0.0350574C40.3943 0.0350574 40.763 0.403521 40.763 0.858175C40.763 0.941811 40.7504 1.02266 40.7272 1.09863",
    id: "Fill-1",
    fill: "#F7F7F7",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.7008 22.3596L64.3968 34.0635C64.3202 34.4564 63.9756 34.7287 63.5897 34.7284L63.5897 34.7291L49.8195 34.7291C49.3649 34.7291 48.9962 34.3604 48.9962 33.9058C48.9962 33.837 49.0048 33.7706 49.0206 33.7069L51.355 21.943L42.9837 1.40808C42.8132 0.987108 43.0162 0.507827 43.4372 0.337303C43.5566 0.28898 43.6807 0.270626 43.801 0.278758L56.063 0.164223C56.4203 0.161435 56.726 0.387717 56.8408 0.705534L60.6181 10.805L68.8537 0.584726C69.0156 0.383303 69.2535 0.278525 69.4935 0.278293L69.4935 0.276202L83.1355 0.276202C83.5901 0.276202 83.9588 0.644665 83.9588 1.09932C83.9588 1.32328 83.8694 1.5261 83.7244 1.67455L66.7008 22.3596Z",
    id: "Fill-4",
    fill: "#F5F5F5",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8772 15.5323C100.266 15.5323 101.221 14.7289 101.645 13.7799C101.789 13.4574 101.872 13.1206 101.889 12.7955C101.906 12.4891 101.864 12.1959 101.76 11.9404C101.55 11.4232 101.033 11.048 100.161 11.048L98.5096 11.048L97.5701 15.5323L98.8772 15.5323ZM102.969 0.058005C104.531 0.058005 105.97 0.188105 107.285 0.448074C108.616 0.711063 109.821 1.1088 110.901 1.64082C111.995 2.1798 112.928 2.84123 113.699 3.62462C114.478 4.41474 115.088 5.32545 115.53 6.35603L115.609 6.54235C116.917 9.77465 116.465 13.5357 114.738 16.8837C113.035 20.1869 110.081 23.1016 106.355 24.6993C106.261 24.7395 106.16 24.782 106.048 24.827L106.048 24.828C104.771 25.3451 103.414 25.7343 101.978 25.9952C100.548 26.2551 99.0579 26.385 97.509 26.385L95.1472 26.385L93.5119 33.7787C93.4274 34.1613 93.0877 34.422 92.7111 34.4217L92.7111 34.4247L79.978 34.4247C79.5236 34.4247 79.1549 34.056 79.1549 33.6016C79.1549 33.5145 79.1686 33.4306 79.1934 33.3516L86.4154 0.704325C86.5 0.321458 86.8396 0.0607928 87.2162 0.0612575L87.2162 0.0582373L102.969 0.0582373L102.969 0.058005Z",
    id: "Fill-6",
    fill: "#F5F5F5",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(149.61554 0.2115235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.166924 0.166529L37.0291 0.166529L37.0291 34.2131L0.166924 34.2131L0.166924 0.166529Z",
    id: "Clip-9",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7043 15.4896C21.0757 15.4896 22.0192 14.696 22.4378 13.759C22.58 13.4405 22.6615 13.108 22.6792 12.7872C22.6954 12.485 22.6541 12.1957 22.5519 11.9439C22.3449 11.4346 21.8349 11.0652 20.9763 11.0652L19.347 11.0652L18.4203 15.4896L19.7043 15.4896ZM23.7558 0.166529C25.3033 0.166529 26.7286 0.295467 28.0321 0.552881C29.3503 0.813546 30.5445 1.20733 31.6141 1.73447C32.6978 2.26881 33.6223 2.92419 34.3873 3.70062C35.1591 4.48401 35.764 5.38635 36.202 6.40763C36.2247 6.46107 36.2508 6.5231 36.2789 6.59303L36.28 6.59256C37.5759 9.79536 37.1282 13.522 35.4176 16.8394C34.059 19.4737 31.8968 21.8589 29.1796 23.5147L32.5506 33.0494C32.7013 33.4776 32.4769 33.9471 32.049 34.0979C31.9586 34.1297 31.8664 34.1448 31.7755 34.1448L31.7755 34.146L18.7715 34.146C18.3875 34.146 18.0648 33.883 17.9742 33.5273L15.8468 27.0232L14.3995 33.5668C14.3149 33.9494 13.9752 34.2103 13.5989 34.2101L13.5989 34.2131L0.990274 34.2131C0.535619 34.2131 0.166924 33.8444 0.166924 33.3898C0.166924 33.3027 0.180631 33.2188 0.205489 33.14L7.35683 0.812849C7.4414 0.429982 7.78105 0.169316 8.15742 0.169549L8.15742 0.166529L23.7558 0.166529Z",
    id: "Fill-8",
    fill: "#F5F5F5",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(115.92881 1.3731349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0387645 0.0170989L38.6128 0.0170989L38.6128 45.5352L0.0387645 45.5352L0.0387645 0.0170989Z",
    id: "Clip-12",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96542 0.0751795L36.8175 0.0170989C39.233 0.0170989 38.8629 2.20093 37.7331 2.913L22.6254 13.9058L29.343 13.9532C31.1031 14.034 31.0401 16.0901 29.863 16.7787L14.8761 27.6463L20.597 27.5824C22.2639 27.6876 22.408 29.3134 20.9532 30.2768L2.78882 45.1067C1.34261 46.0592 -0.445106 45.388 0.159629 43.4493L4.0199 31.4584C4.0645 31.3453 2.31395 31.8141 2.49377 29.6719C2.51073 29.4704 2.54465 29.246 2.59878 28.9956L5.29442 15.829C3.93533 15.7525 3.09223 15.4914 3.4147 13.5884L4.96754 3.6167C5.25027 1.83595 5.88196 0.113513 7.96542 0.0751795",
    id: "Fill-11",
    fill: "#C58900",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.748 0.0580282L152.6 -5.23736e-05C155.015 -5.23736e-05 154.645 2.18378 153.516 2.89584L138.408 13.8886L145.125 13.936C146.886 14.0169 146.823 16.0729 145.645 16.7615L130.659 27.6291L136.014 27.5652C137.68 27.6705 138.044 29.3692 136.443 30.5524L118.571 45.0895C117.125 46.042 115.703 45.3711 116.308 43.4321L118.192 34.9538C118.237 34.8406 116.486 35.3092 116.666 33.1672C116.683 32.9655 116.717 32.7414 116.771 32.4911L119.613 19.324C118.254 19.2478 117.411 18.9869 117.734 17.0835L120.75 3.59955C121.033 1.81903 121.664 0.0963614 123.748 0.0580282Z",
    id: "Fill-14",
    fill: "#F4EF00",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ce25c128251df4b5a0be6503cb3aac3.svg";
export { ForwardRef as ReactComponent };